<template>
  <div>
    <review-order ref="order" :type="type" @clearDetails="clearDetails" @showDetails="showDetails"/>
    <review-detail ref="details"/>
  </div>
</template>
<script>
import ReviewOrder from '@/views/outbound/review_template/ReviewOrder.vue'
import ReviewDetail from '@/views/outbound/review_template/ReviewDetail.vue'

export default {
  name: 'ReviewTemplate',
  components: { ReviewOrder, ReviewDetail },
  data() {
    return {}
  },
  props: {
    type: {
      type: String,
      default: ''
    }
  },
  methods: {
    showDetails(row) {
      this.$refs.details.refresh(row.order.id)
    },
    clearDetails() {
      this.$refs.details.clear()
    }
  }
}
</script>